<template>
  <main>
    <section class="fk-contents">
    <h2 class="title-lv2" style="text-align: center;">【特定商取引法に基づく表記(d払いミニアプリ利用)】</h2>
    <p class="comp-read" style="text-align: right;">2020.12.03</p>
    <p class="title-lv3">販売事業者名</p>
    <p class="comp-read">ファーストキッチン株式会社</p>
    <p class="title-lv3">モバイルオーダー業務責任者</p>
    <p class="comp-read">マーケティング部 部長 高関 類</p>
    <p class="title-lv3">事業者の住所</p>
    <p class="comp-read">〒160-0004 東京都新宿区四谷4丁目34番1号 新宿御苑前アネックスビル5F</p>
    <p class="title-lv3">お問い合わせ先</p>
    <p class="comp-read">お問い合わせフォーム:<a href="https://www.first-kitchen.co.jp/contact/" target="_blank">こちら</a>からお問い合わせください。</p>
    <p class="title-lv3">連絡先</p>
    <p class="comp-read">商品に関するお問い合わせは、ご注文いただきました店舗へ直接お電話にてお願いいたします。</p>
    <p class="title-lv3">提供商品</p>
    <p class="comp-read">ハンバーガー等の飲食物</p>
    <p class="title-lv3">販売価格</p>
    <p class="comp-read">当サイトで表示された商品代金(表示価格)による販売。<br>
表示価格は税込み価格で表示してあります。</p>
    <p class="title-lv3">お支払方法・期限</p>
    <p class="comp-read">d払い「当サイトでのご注文時」</p>
    <p class="title-lv3">取引についての特約に関する事項</p>
    <p class="comp-read">・商品の性質上、お客様のご都合での返品はお断りさせていただきます。<br>
また、商品出来上がり通知後30分以上過ぎた場合は、キャンセル扱いとさせていただく場合がございます。<br><br>

・ご注文いただいた商品に品間違いや不良がございましたら、商品購入当日に 注文店舗まで直接お電話にてご連絡ください。商品のお引き取りをさせていただき交換または返金させていただきます。商品のお取り置きのない場合は、交換または返金の対象外とさせていただく場合がございますので、ご了承願います。
</p>
      <p class="mod-form-btn btn-back"><a href="#" class="btn-base btn-negative btn-quit" @click.prevent="goTop">{{text.GoTop}}</a></p>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
export default {
  name: 'FKMOTokusho',
  mixins: [ CommonMixin ],
  data () {
    return {
      text: {
        GoTop: null
      }
    }
  },
  methods: {
    goTop: function () {
      this.$router.push({ name: 'Index' })
    },
    initView: function () {
      this.text.GoTop = this.$i18n.t('OrderHistory.GoTop')
    }
  },
  // onload
  mounted () {
    this.initView()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Tokusho.vue